import React, { useState, useEffect, useRef } from 'react';
import './Otp.css';
import { path } from "../../UrlApi/UrlApi";
import { TestgenerateToken, TestverifyOTP } from './OtpApi.jsx';
import {
    AlertError,
    AlertSuccess
} from "../../Components/AlertDialog/AlertDialog";

const PhoneNumberForm = () => {
    const [otp, setOTP] = useState(['', '', '', '', '', '']);
    const [countdown, setCountdown] = useState(300);
    const [isOtpRequested, setOtpRequested] = useState(false);
    const codesRef = useRef([]);

    const OPT = async () => {
        const user_name = localStorage.getItem("user_name");
        const ipAddress = localStorage.getItem("ip_address");
        console.log("Requesting OTP");
        TestgenerateToken(ipAddress, user_name);
        setOtpRequested(true);
    };
    const handleSignIn = async (event) => {
        try {
            event.preventDefault();
            // const token = TestgetNewToken(); // รับค่า token จากที่ทำการ generate มา
            const OTP = otp.join('');
            await TestverifyOTP(OTP);
            console.log('Login successful');
            AlertSuccess('เข้าสู่ระบบสำเร็จ', () => {
                window.location.replace(path + '/main');
            }, 3000);
        } catch (error) {
            console.log(error);
            AlertError(error, () => { });
            console.log(error);
        }
    };
    const handleCodeChange = (event, index) => {
        const value = event.target.value;
        if (/^[0-9]*$/.test(value) && value.length <= 1) {
            const updatedOTP = [...otp];
            updatedOTP[index] = value;
            setOTP(updatedOTP);

            if (value.length === 0 && index > 0) {
                codesRef.current[index - 1].focus();
            } else if (value.length === 1 && index < 5) {
                codesRef.current[index + 1].focus();
            }
        }
    };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (isCodeComplete) {
                handleSignIn();
            }
        }
    };


    useEffect(() => {
        codesRef.current[0].focus();
    }, []);


    useEffect(() => {
        const countdownTimer = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        if (countdown === 0) {
            clearInterval(countdownTimer);
            window.history.back();
            setOtpRequested(false);
        }

        return () => {
            clearInterval(countdownTimer);
        };
    }, [countdown]);

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    const isCodeComplete = otp.length === 6 && otp.every((value) => value !== '');

    return (
        <div className="bodyOTP">
            <div className="container">
                <h2>{isOtpRequested ? 'กรุณากรอกรหัส OTP' : 'ขอรับ OTP ที่แอดมิน'}</h2>
                <div className="countdown-timer">เหลือเวลา : {formatTime(countdown)}</div>
                <div className="code-container">
                    {[...Array(6)].map((_, index) => (
                        <input
                            placeholder="0"
                            min="0"
                            max="9"
                            required
                            key={index}
                            type="number"
                            maxLength="1"
                            value={otp[index] || ''}
                            onChange={(e) => handleCodeChange(e, index)}
                            className="code"
                            ref={(el) => (codesRef.current[index] = el)}
                            onKeyPress={handleKeyPress}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSignIn(e);
                                }
                            }}
                            disabled={!isOtpRequested}
                        />
                    ))}
                </div>
                <div>
                    {isOtpRequested ? (
                        <button
                            type="button"
                            className={`btn btn-primary ${!isCodeComplete ? 'disabled' : ''}`}
                            onClick={handleSignIn}
                            disabled={!isCodeComplete}
                        >
                            ยืนยัน OTP
                        </button>
                    ) : (
                        <button
                            type="button"
                            className={`btn btn-primary ${isCodeComplete ? 'disabled' : ''}`}
                            onClick={OPT}
                            disabled={isCodeComplete}
                        >
                            ขอรับ OTP
                        </button>
                    )}
                </div>
                <small className="info">
                    เมื่อหมดเวลาแล้ว จะได้เข้าสู่ระบบใหม่!
                </small>
            </div>
        </div>
    );
};

export default PhoneNumberForm;
